// src/hooks/settings/use-track-local-app-settings/use-track-local-app-settings.ts
import { UserProperties } from "@youversion/analytics-youversion-private";
import { useEffect, useState } from "react";
function useTrackLocalAppSettings({
  isSignedIn,
  /** De-structuring to prevent infinite renders if the userProperties object is not memoized. */
  settings: {
    adid,
    appAudioBibleVersionId,
    appBibleVersionId,
    appPlanLanguageTag,
    braze_device_id,
    contentType,
    firebase_id,
    idfv,
    osNotificationsEnabled,
    planReminderEnabledIds,
    prayerReminderEnabled,
    prayerReminderTime,
    streaksReminderEnabled,
    votdImageNotificationsEnabled,
    votdImageNotificationsLanguageTag,
    votdImageNotificationsTime,
    votdTextNotificationsEnabled,
    votdTextNotificationsTime,
    votdTextNotificationsVersionId
  }
}) {
  "use client";
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    setInitialized(true);
  }, []);
  useEffect(() => {
    UserProperties.fire({
      adid,
      appAudioBibleVersionId,
      appBibleVersionId,
      appPlanLanguageTag,
      braze_device_id,
      contentType,
      firebase_id,
      idfv,
      osNotificationsEnabled,
      planReminderEnabledIds,
      prayerReminderEnabled,
      prayerReminderTime,
      streaksReminderEnabled,
      votdImageNotificationsEnabled,
      votdImageNotificationsLanguageTag,
      votdImageNotificationsTime,
      votdTextNotificationsEnabled,
      votdTextNotificationsTime,
      votdTextNotificationsVersionId
    });
  }, [
    adid,
    appAudioBibleVersionId,
    appBibleVersionId,
    appPlanLanguageTag,
    braze_device_id,
    contentType,
    firebase_id,
    idfv,
    initialized,
    isSignedIn,
    osNotificationsEnabled,
    planReminderEnabledIds,
    prayerReminderEnabled,
    prayerReminderTime,
    streaksReminderEnabled,
    votdImageNotificationsEnabled,
    votdImageNotificationsLanguageTag,
    votdImageNotificationsTime,
    votdTextNotificationsEnabled,
    votdTextNotificationsTime,
    votdTextNotificationsVersionId
  ]);
}

export {
  useTrackLocalAppSettings
};
